import { formatNumberToExcelUsage } from '@commons/DisplayNumber';

export const transformNumber = (value) =>
  value == null ? null : formatNumberToExcelUsage(value, 2);

export default {
  transformNumber,
};
